"use client";

import { sendLoginUrl } from "@/helpers/server-actions/actions";
import { validateEmail } from "@/helpers/utils/utility-functions";
import { startLoader, stopLoader } from "@/redux/features/app-slice";
import { AppDispatch } from "@/redux/store";
import { usePathname } from "next/navigation";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import Button from "../Button/Button";

type LoginViaEmailPropType = {
  changeLoginMethod: () => void;
  handleEmailSent: (email: string, isEmailSent: boolean) => void;
};

export default function LoginViaEmail({
  changeLoginMethod,
  handleEmailSent
}: LoginViaEmailPropType) {
  const [email, setEmail] = useState<string>("");
  const currentPath = usePathname();
  const dispatch = useDispatch<AppDispatch>();

  const emailNotValidMessage = (
    <div className="flex justify-start items-center">
      <img
        className="h-13 w-25 mt-2"
        src="/images/error_icon.svg"
        alt="c-tribe"
      />
      <p className="mt-2 ml-2 text-[#CD0A0A]  font-medium text-sm leading-5">
        Please enter a valid email address.
      </p>
    </div>
  );

  const handleLogIn = (e: any) => {
    e.preventDefault();
    if (!validateEmail(email)) {
      return;
    }
    dispatch(startLoader(""));
    const afterLoginRedirectUrl = `${window.location.href}`;
    const origin = window.location.origin;
    const redirectUrl = `${origin
      }/email-redirect?email=${encodeURIComponent(
        email
      )}&redirectUrl=${encodeURIComponent(afterLoginRedirectUrl)}`;

    sendLoginUrl(email, redirectUrl).then((isSuccess) => {

      dispatch(stopLoader());
      handleEmailSent(email, true);
    });
  };

  const submitButtonClasses = `w-full h-9 p-2 rounded-full font-bold text-sm leading-5
  mb-6 mt-2 ${!validateEmail(email) ? "cursor-not-allowed" : ""
    } ${!validateEmail(email) ? "bg-button-disabled-color bg-opacity-70" : "bg-button-enabled-color"} ${!validateEmail(email) ? "text-[#616161]" : "text-white"
    }`;

  return (
    <>
      <form data-testid="form" onSubmit={handleLogIn}>
        <div className="py-4">
          <div className="flex justify-between items-center mt-2 ">
            <p className="mx-0 text-left font-normal text-sm leading-5 text-custom-gray">
              Email
            </p>

            <div className="flex items-center mb-1.5">
              <div className="flex justify-start items-center mt-1.5 opacity-50 cursor-not-allowed">
                <img
                  className="h-5.5 w-5.5"
                  src="/images/phone_icon.svg"
                  alt="c-tribe"
                />
                <p className="ml-1 mb-0 text-left font-medium text-sm leading-5 text-custom-gray">
                  Phone Login
                </p>
                <span className="ml-2 px-1.5 py-0.5 text-xs font-medium bg-gray-200 text-gray-600 rounded">
                  Coming Soon
                </span>
              </div>
            </div>
          </div>

          <div>
            <input
              type="text"
              className={`w-full h-9 p-2 bg-white focus:bg-white rounded-[0.625rem] text-sm placeholder:font-light placeholder:text-gray-500 text-custom-gray ${email ? 'border-[1px] border-[#333E48]' : ""}`}
              name="email"
              id="email"
              value={email}
              placeholder="elon@spacex.com"
              onChange={(e) => setEmail(e.target.value)}
            />
            {email && !validateEmail(email) && emailNotValidMessage}
            {/* {isLoginClicked && emailSentWithLoginLinkMessage} */}
          </div>
        </div>
        <Button
          type="submit"
          data-testid="submit"
          label="CONTINUE WITH EMAIL"
          disabled={!validateEmail(email)}
          className={submitButtonClasses}
          width="100%"
        >

        </Button>
      </form>
    </>
  );
}
